// extracted by mini-css-extract-plugin
export default {"root":"Download__root--2Vgjj","icon":"Download__icon--1HQXA","downloadJpegIconOpen":"Download__downloadJpegIconOpen--3R3yr"};